import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { GroupService } from './../../../group.service';
import { UserService } from './../../../user.service';

import { Wave } from './../../../../../models/program/wave';
import { Group } from './../../../../../models/program/group';

@Component({
  selector: 'app-group-manage',
  templateUrl: './group-manage.component.html',
  styleUrls: ['./group-manage.component.less']
})

export class GroupManageComponent implements OnInit {
  @Input() inputType: string;
  @Input() groupId: number;
  @Input() groups: number[];
  @Input() programId: number;
  @Output() recall: EventEmitter<boolean> = new EventEmitter<boolean>();
  public waves: Wave[];
  public _groups: Group[];
  public targetWave: number;
  public targetGroup: number;
  public confirmBulkDelete = false;
  public move = false;

  constructor(
    private groupSevice: GroupService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    if (this.inputType === 'group') {
      this.groupSevice.getWaves(this.programId)
                      .subscribe(waves => this.waves = waves);
    }
    if (this.inputType === 'user' ) {
      this.groupSevice.getAllGroups(this.programId)
                      .subscribe(groups => this._groups = groups);
    }
   }

   public setWave(value: string): void {
     if (value !== 'null') {
      console.log('Not null:', value);
      let wave = parseInt(value, 10);
      this.targetWave = wave;
     } else {
       console.log('null:', value);
       this.targetWave = null;
     }
     console.log('target:', this.targetWave);
   }

   public setGroup(value: string): void {
     if (value !== 'null') {
       console.log('Not null:', value);
       let group = parseInt(value, 10);
       this.targetGroup = group;
     } else {
       console.log('null:', value);
       this.targetGroup = null;
     }
     console.log('target:', this.targetGroup);
   }

   public cancel(): void {
     console.log(this.groups);
     this.recall.emit(false);
   }

   public moveGroups(targetWave: number | null): void {
     this.groupSevice.moveGroups(this.programId, { group_ids: this.groups, wave_id: targetWave })
                     .subscribe(() => this.recall.emit(true));
   }

   public moveUsers(targetGroup: number | null): void {
     let generatedUserObject = this.groups.map(userId => ({'id': userId}));
     this.userService.addGroupUsers(this.programId, targetGroup, generatedUserObject)
                     .subscribe(() => this.recall.emit(true));
   }

   public bulkDelete(user?: boolean): void {
     if (!user) {
       this.groupSevice.deleteGroup(this.programId, this.groups)
                       .subscribe(() => this.recall.emit(true));
     } else {
       this.userService.deleteGroupUsers(this.programId, this.groupId, this.groups)
                       .subscribe(() => this.recall.emit(true));
     }
   }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/groups/group-manage/group-manage.component.ts